import script from "./LoginRegisterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginRegisterPage.vue?vue&type=script&setup=true&lang=js"

import "./LoginRegisterPage.vue?vue&type=style&index=0&id=52482bde&lang=css"

const __exports__ = script;

export default __exports__